import { usePlanEditor } from './editor';

import { ProjectHeaderBar } from '@/components/project';

/**
 * `ProjectHeaderBar` wired to the plan editor.
 *
 * It exists for the rename: the name has to go through the editor's own
 * document, because `useAutosave` PUTs that whole document against the
 * last-known version (BR-20) — a separate project PUT would race it into a 409.
 * Reading the name from the editor too is what makes the new title appear the
 * moment it is committed, rather than after the save round-trips.
 */

export const PlanProjectHeader = () => {
  const { state, dispatch } = usePlanEditor();
  const { document } = state;

  return (
    <ProjectHeaderBar
      projectName={document.name}
      projectCode={document.code}
      onRename={(name) => dispatch({ type: 'SET_PROJECT_NAME', name })}
    />
  );
};
